<!-- template v.1 -->
<template>
      <div class="wrapper-login">
        <div class="container-login" @submit.prevent="Login">
            <img src="../assets/logo.png" class="logo" > 
            <form>
               <label class="form-label ">Usuario</label>
                <div class="input-group mb-3">
                    <input type="text" class="form-control" autocomplete="off" maxlength="80" v-model="Usuario">
                    <span class="input-group-text"><i class="fas fa-user"></i></span>
                </div>
                <label class="form-label">Contraseña</label>
                <div class="input-group mb-3">
                    <input type="password" class="form-control" maxlength="20" autocomplete="off" v-model="Password"  >
                    <span class="input-group-text"><i class="fas fa-lock"></i></span>
                </div>
                <div class="d-grid gap-2 col-12 mx-auto">
                    <button type="submit" class="btn btn-primary color-button">Ingresar</button>
                </div>
            <div class="overlay-wrapper"  v-if="load">
                <div class="overlay" style="flex-direction: column;">
                    <i class="spinner-border"></i>
                    <div class="text-bold pt-2">Cargando...</div>
                </div>
            </div>
            </form>
            
        </div>
      </div>     
</template>
<script>
export default {
  props: ["content"],

  data: function () {
    return {
      load: false,
      Usuario:"",
      Password:"",

      
    };
  },
  mounted(){
  /*  this.content.login = true;
    this.content.sistema = false;
    if(localStorage.token){
    window.location.href = this.$store.state.asistencia+'/home'
    }*/
  },
  methods: {
    Login(){
        this.load=true;
        var usuario = this.Usuario;
        var password = this.Password;
        var bodyFormData = new FormData();
        bodyFormData.append("user", usuario);
        bodyFormData.append("password", password);
        const ipseguridad = this.$store.state.seguridad;
        this.axios.post(ipseguridad+"/auth/login", bodyFormData)
        .then((response) => {
             const resultado = response.data.oResult.satisfactorio;
           const token = response.data.sToken;
          
           this.load=false;
          if (resultado == true) { 
         
              /*  window.location.href = this.$store.state.asistencia+'/auth?token=' + token;
                */
               this.content.token=true;
               
                localStorage.token = token;
               this.$router.push('home');
           
          }
          else
          {
            this.$swal({
            toast: true,
            timer:3000,
            position: 'top',
            showConfirmButton: false,
            title: 'Usuario o clave incorrectos',
            icon: 'error',
            
            });  
          }


        });
    }
  },
}
</script>
<style scoped>
.flex-nowrap {
    flex-wrap: wrap !important;
}
</style>